<template>
  <div v-if="homepage">
    <h3>Brand Visual</h3>
    <div class="h4 py-5">顯示於首頁置頂區域</div>
    <div class="form-item py-5 d-flex">
      <h4 class="w-174px mr-6px flex-shrink-0">Title</h4>
      <div class="h4">
        (Innovating the future 為圖檔，在後台不提供更改)
      </div>
    </div>
    <div class="form-item py-5 d-flex">
      <h4 class="w-174px mr-6px flex-shrink-0">Background</h4>
      <div class="h4">
        (圖檔有微動態設定，因此在後台不提供更改)
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    homepage: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style></style>
